// LeaderboardCategoryUser.js
import { connect } from 'react-redux';
import LeaderboardCategoryUser from '../component/LeaderboardCategoryUser.jsx';
import fetchUser from '../action/fetchUser.js';
import getUserData from '../selector/getUserData.js';

const mapStateToProps = (state, { userId }) => {
  return {
    username: getUserData(state, userId, 'username'),
  };
};

const mapDispatchToProps = (dispatch, { userId }) => {
  return {
    fetchUser: () => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true }
)(LeaderboardCategoryUser);
